export default function ContactSection() {
  return (
    <section id="contact" className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-amber-100 text-amber-700 text-sm font-medium px-4 py-2 rounded-full mb-6">
            <i className="ri-customer-service-2-line"></i>
            <span>상담 문의</span>
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4 leading-tight">
            지금 바로<br />
            <span className="text-amber-500">전화 상담</span>을 받아보세요
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed mb-10">
            퇴실청소, 특수청소, 유품정리 — 어떤 상황이든 편하게 연락주세요.<br />
            비대면 신청도 가능하며, 개인정보는 철저히 보호됩니다.
          </p>

          <a
            href="tel:01055608051"
            className="inline-flex items-center gap-3 bg-amber-500 hover:bg-amber-600 text-white font-bold text-xl px-10 py-5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-fill text-2xl"></i>
            <span>010-5560-8051</span>
          </a>

          <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              { icon: "ri-phone-line", title: "전화 상담", desc: "010-5560-8051", sub: "언제든지 연락주세요" },
              { icon: "ri-kakao-talk-line", title: "카카오톡 상담", desc: "카톡으로 문의", sub: "24시간 접수 가능" },
              { icon: "ri-eye-off-line", title: "비대면 신청", desc: "모든 서비스 조율 가능", sub: "개인정보 철저 보호" },
            ].map((item) => (
              <div key={item.title} className="flex flex-col items-center gap-3 bg-white rounded-2xl p-6 border border-gray-100">
                <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-xl">
                  <i className={`${item.icon} text-amber-600 text-xl`}></i>
                </div>
                <div className="text-center">
                  <div className="font-semibold text-gray-900 mb-0.5">{item.title}</div>
                  <div className="text-amber-600 font-medium text-sm">{item.desc}</div>
                  <div className="text-xs text-gray-400 mt-0.5">{item.sub}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
